module.exports = __webpack_public_path__ + "img/logo-playstation.7fc2393f.svg";